/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FiChevronRight } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SearchFilterSection from "../../components/common/SearchFilterSection";
import PendingRequestTable from "../../components/tables/PendingRequestTable";
import { getUniqueValues } from "../../libs/UnauthorisedPage";
import { getApiCaller } from "../../libs/apiCaller";

const PendingRequestList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const providerId = location.state?.providerId;
  const providerName = location.state?.providerName;
  const type = location.state?.type;

  const [pendingAppointments, setPendingAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filteredPendingAppointments, setFilteredPendingAppointments] =
    useState([]);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const fetchPendingAppoinments = async () => {
    try {
      const response = await getApiCaller(
        `provider_appointment_list?type=${type}&provider_id=${providerId}`
      );

      const PendingResponse = response.data.response_data?.filter(
        (res) => res.status === "Pending"
      );

      setPendingAppointments(PendingResponse);
      setFilteredPendingAppointments(PendingResponse);
      setStates(getUniqueValues(PendingResponse, "billing_state"));
    } catch (error) {
      toast.error("Failed to fetch pending providers. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    providerId && fetchPendingAppoinments();
  }, [providerId]);

  useEffect(() => {
    applyFilters();
  }, [searchTerm, selectedState, selectedCity]);

  const applyFilters = () => {
    let filteredData = pendingAppointments;

    if (searchTerm) {
      filteredData = filteredData.filter((consumer) => {
        const fullName = `${consumer?.patient_name || ""}`?.toLowerCase();
        return fullName?.includes(searchTerm?.toLowerCase());
      });
    }

    if (selectedState) {
      filteredData = filteredData.filter(
        (consumer) => consumer.billing_state === selectedState
      );
      setCities(getUniqueValues(filteredData, "billing_city"));
    } else {
      setCities(getUniqueValues(pendingAppointments, "billing_city"));
    }

    if (selectedCity) {
      filteredData = filteredData.filter(
        (consumer) => consumer.billing_city === selectedCity
      );
    }

    setFilteredPendingAppointments(filteredData);
  };

  const clearFilters = () => {
    setSearchTerm("");
    setSelectedState("");
    setSelectedCity("");
    setFilteredPendingAppointments(pendingAppointments);
    setCities(getUniqueValues(pendingAppointments, "billing_city"));
  };

  return (
    <>
      <div className="px-4 md:px-10 mt-4">
        <nav className="flex flex-col sm:flex-row sm:items-end justify-between mb-3">
          <div className="flex items-center space-x-2">
            <a
              href="/provider"
              className="text-[#284184] text-xl hover:underline"
            >
              All Providers
            </a>
            <span className="text-[#284184]">
              <FiChevronRight className="text-2xl" />
            </span>
            <button
              href="/provider"
              className="text-[#284184] text-xl font-[Lato-Regular] hover:underline"
              onClick={() =>
                navigate("/providerProfile", {
                  state: { provider: { id: providerId } },
                })
              }
            >
              {providerName}
            </button>
            <span className="text-[#284184]">
              <FiChevronRight className="text-2xl" />
            </span>
            <span className="text-[#284184] text-xl font-[Lato-Regular] font-bold">
              Pending Requests
            </span>
          </div>
        </nav>
        <div className="border border-t-0 px-4 py-3 rounded-b-2xl text-xl bg-white">
          <SearchFilterSection
            searchTextPlaceholder={"Search Patient Name"}
            searchTerm={searchTerm}
            selectedCity={selectedCity}
            selectedState={selectedState}
            cities={cities}
            states={states}
            clearFilters={clearFilters}
            setSearchTerm={setSearchTerm}
            setSelectedCity={setSelectedCity}
            setSelectedState={setSelectedState}
          />
          <PendingRequestTable
            pendingAppointments={filteredPendingAppointments}
            loading={loading}
            providerId={providerId}
            providerName={providerName}
            type={type}
          />
        </div>
      </div>
    </>
  );
};

export default PendingRequestList;
